import { createContext } from 'react';

/**
 * Tab ordering for the v2 subscription-management surface. The provider owns only the `?tab=`
 * selection state; section visibility (the BE `/preflight` flags) lives in `PreflightProvider`, and
 * the visible-tab list is derived in `PageInner`.
 */
export const SUBSCRIBE_TABS = ['general', 'groups', 'billing', 'orders', 'podcasts'] as const;
export type TabKey = (typeof SUBSCRIBE_TABS)[number];

export type TabStateContextType = {
  /** Currently active tab, resolved from the `?tab=` param (defaults to `general`). */
  activeTab: TabKey;
  /** Select a tab; writes `?tab=` (or clears it for `general`) without scroll reset. */
  setActiveTab: (tab: TabKey) => void;
};

export const TabStateContext = createContext<TabStateContextType | undefined>(undefined);
TabStateContext.displayName = 'TabStateContext';
